import HappyHour from 'js/components/pages/CheckoutPage/DropOffDetailsV2/HappyHour';
import { Section } from 'js/new/Components';
import { AppButton } from 'js/new/Components/App';
import CopyItemLink from 'js/new/Components/App/Item/CopyItemLink';
import Pagination from 'js/new/Components/App/Pagination';
import ReferralBanner from 'js/new/Components/App/Seller/ReferralBanner';
import App from 'js/new/Layouts/AppLayout';
import { formatCurrency } from 'js/services/Format';
import { makeRequest, url } from 'js/services/Network';
import AppUser from 'js/stores/AppUser';
import { debounce } from 'lodash';
import React from 'react';
import { Spring, Trail } from 'react-spring';

export default function StoreView() {
  const pageName = 'SellerItemsPage';

  const urlSplit = window.location.href?.split('/');
  const alias = urlSplit[urlSplit.length - 1];

  const [pspData, setPSPData] = React.useState({})
  const [searchTerm, setSearchTerm] = React.useState('');

  const itemsData = pspData?.items ?? [];

  React.useEffect(async () => {
    getData()
  }, []);

  React.useEffect(async () => {
    if (searchTerm !== null) {
      getData(1, searchTerm);
    }
  }, [searchTerm])

  const debouncedSearch = debounce((value, callback) => {
    callback(value);
  }, 300)

  const getData = async (page = 1, search = '') => {
    const response = await makeRequest(
      'seller-partner-data',
      { alias: alias },
      { page: page, count: 10, search: search }
    );

    if (response.status === 200) {
      setPSPData(response.data);
    }
  }

  return (
    <App pageName={pageName} hasHeader={false}>
      {
        (AppUser.isLoggedIn && AppUser.login === alias) &&
        <Section className='tw-space-y-1' pad={'tw-py-2 md:tw-py-4 lg:tw-py-6'}>
          <AppButton flat href={'/dashboard'} className='tw-gap-2 tw-items-center'><img src='/assets/images/icons/essentional.png' width={20} height={20} /> Back to dashboard</AppButton>
          <p>Below  is what your store front looks like to your buyers. Cool right? 😎. You can copy each item link and share to them  or share your store link.</p>
        </Section>
      }

      {pspData.happy_hour === 1 && <HappyHour start_date={pspData.happy_hour_start_time} start_hour={18} />}

      <ReferralBanner />

      <Section className='tw-grid md:tw-grid-cols-3 tw-gap-3 md:tw-gap-6 tw-py-4'>
        <div className='md:tw-col-span-2 tw-rounded-xl tw-p-1 md:tw-p-3' style={{ border: '0.5px solid #EEE' }}>
          <div className='tw-p-1 md:tw-p-3 tw-pb-1 md:tw-pb-2'>
            <h4 className="tw-text-primary tw-mb-0">Shop {pspData ? pspData?.micro_store : 'from someone'}</h4>
            {(pspData && pspData?.psp_data?.approval_status) ? (
              <p className="tw-text-sm tw-text-pretty tw-text-secondary tw-flex tw-gap-2 tw-items-center">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.9658 7.94948L15.8324 6.63281C15.6158 6.38281 15.4408 5.91615 15.4408 5.58281V4.16615C15.4408 3.28281 14.7158 2.55781 13.8324 2.55781H12.4158C12.0908 2.55781 11.6158 2.38281 11.3658 2.16615L10.0491 1.03281C9.47409 0.541146 8.53242 0.541146 7.94909 1.03281L6.64076 2.17448C6.39076 2.38281 5.91576 2.55781 5.59075 2.55781H4.14909C3.26576 2.55781 2.54076 3.28281 2.54076 4.16615V5.59115C2.54076 5.91615 2.36576 6.38281 2.15742 6.63281L1.03242 7.95781C0.549089 8.53281 0.549089 9.46615 1.03242 10.0411L2.15742 11.3661C2.36576 11.6161 2.54076 12.0828 2.54076 12.4078V13.8328C2.54076 14.7161 3.26576 15.4411 4.14909 15.4411H5.59075C5.91576 15.4411 6.39076 15.6161 6.64076 15.8328L7.95742 16.9661C8.53242 17.4578 9.47409 17.4578 10.0574 16.9661L11.3741 15.8328C11.6241 15.6161 12.0908 15.4411 12.4241 15.4411H13.8408C14.7241 15.4411 15.4491 14.7161 15.4491 13.8328V12.4161C15.4491 12.0911 15.6241 11.6161 15.8408 11.3661L16.9741 10.0495C17.4574 9.47448 17.4574 8.52448 16.9658 7.94948ZM12.4658 7.42448L8.44076 11.4495C8.32409 11.5661 8.16576 11.6328 7.99909 11.6328C7.83242 11.6328 7.67409 11.5661 7.55742 11.4495L5.54076 9.43281C5.29909 9.19115 5.29909 8.79115 5.54076 8.54948C5.78242 8.30781 6.18242 8.30781 6.42409 8.54948L7.99909 10.1245L11.5824 6.54115C11.8241 6.29948 12.2241 6.29948 12.4658 6.54115C12.7074 6.78281 12.7074 7.18281 12.4658 7.42448Z" fill="#6D60F6" />
                </svg>
                Verified POD partner seller
              </p>
            ) : <></>}
          </div>

          <hr />

          <div className="tw-p-1 md:tw-p-3 tw-pt-1 md:tw-pt-2 tw-flex tw-items-center tw-justify-between">
            <h5 className='tw-mb-0'>All products</h5>

            <input
              type='search'
              placeholder='Search'
              className='tw-border-gray-100 tw-py-2 tw-px-4 tw-rounded-xl tw-border-solid'
              onChange={(e) => debouncedSearch(e.target.value, setSearchTerm)}
            />
          </div>

          <div className="tw-p-1 md:tw-p-3">
            {itemsData?.data?.length ? (
              <div className='tw-space-y-6'>
                <div className='tw-space-y-6' >
                  {itemsData?.data?.map((item, i) => <div key={i} className='tw-flex tw-justify-between tw-items-center hover:tw-bg-gray-50'>
                    <div className='tw-flex tw-justify-between tw-items-center tw-gap-2 md:tw-gap-3'>
                      <img src={item.image} alt={item.title} className='tw-h-16 md:tw-h-24 tw-w-16 md:tw-w-24 tw-object-cover tw-rounded-xl tw-bg-gray-50' />
                      <div>
                        <p>{item.title}</p>
                        <p style={{
                          fontWeight: 700
                        }}>{formatCurrency(item.price)}</p>
                      </div>
                    </div>
                    <CopyItemLink iconSize={14} className='tw-text-xs tw-p-2' link={window.location.origin + url('checkout-page', item)} copyText={'Copy item link'} />
                  </div>)}
                </div>

                <div className='tw-flex tw-justify-between tw-items-center'>
                  <p>Showing {itemsData?.from ?? 0} to {itemsData?.to ?? 0} of {itemsData?.total ?? 0}</p>
                  <Pagination
                    currentPage={itemsData?.current_page ?? 1}
                    totalPages={itemsData?.last_page ?? 1}
                    onPageChange={(page) => getData(page, searchTerm)}
                  />
                </div>
              </div>
            ) : <div className="tw-text-center tw-p-12">
              <h5>{pspData?.micro_store} has no items for sale yet.</h5>
            </div>}
          </div>
        </div>

        <div className='tw-bg-primary tw-rounded-xl tw-h-fit' style={{height:'fit-content'}}>
          <div className=' tw-space-y-4 tw-p-6 tw-text-white'>
            <h5>Sell with POD</h5>
            <p>Start selling with POD and get the chance to become a POD Seller Partner</p>

            {[
              'Reach more buyers and sell more',
              'Sell faster',
              { text: 'Make extra income', extra: ' with commissions from PSP', bold: true }
            ].map((item, index) => (
              <div key={index} className="tw-flex tw-items-center tw-gap-4">
                <img
                  src="/images/icons/icon-right.png"
                  alt="icon-right"
                  style={{ width: '10px', height: '6.66px' }}
                />
                <p className="tw-text-sm tw-text-faint">
                  {typeof item === 'string' ? item : <>
                    <span className="tw-font-semibold">{item.text} </span>
                    {item.extra}
                  </>}
                </p>
              </div>
            ))}

            <div className="tw-flex tw-gap-4 tw-md:tw-justify-start">
              <button
                className="tw-rounded-lg tw-border tw-border-white tw-py-2 tw-px-2.5 tw-mt-8 tw-mr-5">
                <span className="text-black tw-text-sm tw-font-semibold">learn more</span>
              </button>
              <button className="tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-py-2 tw-px-2.5 tw-mt-8 tw-text-white" >
                Start selling &nbsp;&nbsp;
                <img
                  src="/images/icons/right.svg"
                  alt="shop"
                  className="size-24px"
                />
              </button>

            </div>
          </div>

          <div>
            <img
              src="/images/ssp/bg-desktop2.png"
              alt="bg-desktop"
              className="tw-w-full tw-h-96 tw-object-cover tw-hidden tw-md:tw-block"
            />
            <img
              src="/images/ssp/bg-mobile2.png"
              alt="bg-desktop"
              className="tw-w-full tw-h-32 tw-object-cover tw-md:tw-hidden"
            />
          </div>
        </div>
      </Section>

    </App>
  )
}

